<template>
  <div>
    <el-button
      type="primary"
      size="mini"
      class="elinput"
      @click="centerDialogVisible=true"
      v-if="Permission.indexOf(123)!=-1"
    >{{$t('lang.softwarepackage.Add')}}</el-button>
    <!--xlsx表格导出-->
    <xlsx style="margin-bottom: 0.2rem;margin-top: 0.2rem" v-if="Permission.indexOf(119)!=-1"></xlsx>
    <!-- <p class="tabletitle"></p> -->
<!--    表格组件-->
    <TableComponent
    :Columns="Columns"
    :ColuumnsButton="ColuumnsButton"
    :seek="seek"
    :RowKey="'spId'"
    :data="data"
    :DeleteTitle="$t('lang.softwarepackage.remove_pkg')"
    :ColuumnsButtonWidth="240"
    @DownloadFile="DownloadFile"
    @SetFirmwarePermission="SetFirmwarePermission"
    @showcenterDialogVisibles="showcenterDialogVisibles"
    @delSoftwarePackage="delSoftwarePackage"
    @GetSoftwareType="GetSoftwareType"
    @GetUsername="GetUsername"
    @GetStatus="GetStatus"
    @sortChange="sortChange"
    />
    <!--分页组件-->
    <pagination
      :total="total"
      :offset="offset"
      :limit="limit"
      @SizeChanges="SizeChanges"
      @CurrentChanges="CurrentChanges"
      :show-file-list="false"
    ></pagination>
    <el-dialog
      :title="$t('lang.softwarepackage.addVarCopy')"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <div style="text-align:center;">
        <el-upload
          ref="upload"
          class="upload-demo"
          action="/api/softwarePackageManager/addSoftwarePackage"
          multiple
          drag
          :auto-upload="false"
          :headers="Headers"
          :limit="1"
          :data="uploadpack"
          :on-success="uploadsuccess"
          accept=".tar.gz,.tar">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <em>{{$t('lang.softwarepackage.add_action')}}</em>
          </div>
          <!-- <div
            class="el-upload__tip"
            slot="tip"
            style="text-align:center"
          >{{$t('lang.softwarepackage.file_name')}}</div> -->
        </el-upload>
        <br>
        <el-button
          type="primary"
          size="mini"
          @click="submitUpload"
        >{{$t('lang.softwarepackage.uploaders')}}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="$t('lang.softwarepackage.Modify')"
      :visible.sync="centerDialogVisibles"
      width="30%"
      center>
      <div style="text-align:center;">
        <el-upload
          ref="setupload"
          class="upload-demo"
          action="/api/softwarePackageManager/addSoftwarePackage"
          multiple
          drag
          accept=".tar.gz,.tar"
          :auto-upload="false"
          :headers="Headers"
          :limit="1"
          :show-file-list="false"
          :data="setuploadpack"
          :on-success="setuploadsuccess">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            <em>{{$t('lang.softwarepackage.add_action')}}</em>
          </div>
          <!-- <div
            class="el-upload__tip"
            slot="tip"
            style="text-align:center"
          >{{$t('lang.softwarepackage.file_name')}}</div> -->
        </el-upload>
        <br>
        <el-button
          type="primary"
          size="mini"
          @click="setsubmitUpload"
        >{{$t('lang.softwarepackage.uploaders')}}</el-button>
      </div>
    </el-dialog>
    <Dialog :Show="DialogShow" @DialogResponse="DialogResponse" :title="$t('lang.softwarepackage.FirmwareAuthority')" :spPermission="spPermission"
    @SubmitModify="updateSoftwarePackagePermission"></Dialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination";
import xlsx from "@/components/xlsx";
import { Columns,ColuumnsButton } from "./TableConfig";
import {
  getSoftwarePackageList,
  delSoftwarePackage,
  addSoftwarePackage,
  queryKeyword,
  updateSoftwarePackagePermission,
  softwarePackageManager
} from "@/api/softwarepackage";
import {getPermission, getToken} from "../../../cookie/cookie";
import { PublicComponent } from "../../../mixins/common";
import { getuser_iscustomer,getuser_ctid } from '@/localStorage/localStorage'
//固件权限弹出框
import Dialog from '@/components/Dialog'
import TableComponent from '@/components/TableComponent/index'
export default {
  mixins: [PublicComponent],
  data() {
    return {
      Columns:Columns,
      ColuumnsButton:ColuumnsButton,
      //用户权限
      Permission: [],
      data: [],
      user_ctid:getuser_ctid(),
      user_iscustomer:getuser_iscustomer(),
      //弹出层组件
      centerDialogVisible: false,
      //修改弹出框组件
      centerDialogVisibles: false,
      value: "",
      input: "",
      //权限弹出框控制。。
      DialogShow:false,
      //获取当前点击权限固件ID
      spId:'',
      //当前固件权限
      spPermission:'',
      //搜索框组件
      seek: {
        spName: "",
        spVersion: "",
        spType: "",
        spSize: "",
        username: "",
        spCreate: "",
        md5:"",
        spSynStatus: ''
      },
      sort: {
        spName: null,
        spVersion: null,
        spType: null,
        spSize: null,
        username: null,
        spCreate: null,
        md5:null,
        spSynStatus: null
      },
      files: null,
      //上传额外参数
      uploadpack: {
        spId: 0
      },
      setuploadpack: {
        spId: null
      },
      //下载路径
      url:
        window.location.port == ""
          ? "http://" + document.domain
          : "http://" + document.domain + ":" + window.location.port,
      //上传添加token
      Headers:{
        token:getToken()
      }
    }
  },
  components: {
    pagination,
    xlsx,
    Dialog,
    TableComponent
  },
  methods: {
    getfile(event) {
      this.files = event.target.files[0];
    },
    //删除软件包
    delSoftwarePackage(row) {
      delSoftwarePackage(row.spId).then(res => {
        if (res.data.code == 0) {
          this.$message({
            showClose: true,
            message: this.$t("lang.softwarepackage.TestDelete"),
            type: "success"
          });
          this.getSoftwarePackageList();
        } else {
          this.$message({
            showClose: true,
            message: this.$t("lang.softwarepackage.bdb_delete"),
            type: "warning"
          });
        }
      });
    },
    addSoftwarePackage() {
      addSoftwarePackage(this.files).then(res => {
        console.log(res.data);
      })
    },
    //下载文件
    DownloadFile(row){
      // softwarePackageManager(row.spPath,row.spName)
      // .then((res)=>{
      //   console.log(res)
      // })
      window.open(location.origin+'/api/softwarePackageManager/download?downloadUrl='+row.spPath+'&realFileName='+row.spName)
    },
    //上传文件
    submitUpload() {
      this.$refs.upload.submit();
    },
    //弹出修改框并且获取需要修改的软件包id
    showcenterDialogVisibles(row) {
      this.setuploadpack.spId = row.spId;
      this.centerDialogVisibles = !this.centerDialogVisibles;
    },
    //修改文件
    setsubmitUpload() {
      this.$refs.setupload.submit();
    },
    //获取软件包列表
    getSoftwarePackageList() {
      getSoftwarePackageList(this.offset, this.limit).then(res => {
        this.data = res.data.data.list;
        this.total = res.data.data.total;
        this.data.unshift({});
      });
    },
    //上传返回提示
    uploadsuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          showClose: true,
          message: this.$t("lang.softwarepackage.justUploaded"),
          type: "success"
        });
        this.queryKeyword();
        this.centerDialogVisible = !this.centerDialogVisible;
        this.$refs.upload.clearFiles();
      } else {
        this.$message({
          showClose: true,
          message: this.$t("lang.softwarepackage.successfully"),
          type: "warning"
        });
      }
    },
    //修改上传返回提示
    setuploadsuccess(response, file, fileList) {
      if (response.code == 0) {
        this.$message({
          showClose: true,
          message: this.$t("lang.softwarepackage.justUploaded"),
          type: "success"
        });
        this.getSoftwarePackageList();
        this.centerDialogVisibles = !this.centerDialogVisibles;
        this.$refs.setupload.clearFiles();
      }
    },
    //条件查询
    queryKeyword() {
      queryKeyword(
        [
          this.seek.spName,
          this.seek.spVersion,
          this.seek.spType,
          this.seek.spSize,
          this.seek.md5,
          this.seek.username,
          this.seek.spCreate,
          this.seek.spSynStatus
        ],
        this.offset,
        this.limit,
        this.sort
      ).then(res => {
        this.total = res.data.data.total;
        this.data = res.data.data.list;
        this.data.unshift({});
      });
    },
    //表格排序
    sortChange(column) {
      //每次点击清空一次排序的赋值
      this.sort = {
        spName: null,
        spVersion: null,
        spType: null,
        spSize: null,
        username: null,
        spCreate: null,
        md5:null,
        spSynStatus: null
      };
      // 未找到索引等信息，采用id值判断 //获取当前#id值，截取最后一个字符串转换成数字，再减1获取到当前索引
      let label = null;
      if (column != null) {
        label = column.label;
      } else {
        label = null;
      }
      let sortlist = null;
      if (column != null) {
        if (column.order == "ascending") {
          sortlist = 0;
        } else if (column.order == "descending") {
          sortlist = 1;
        } else {
          sortlist = null;
        }
      }
      if (label == this.$t("lang.softwarepackage.Software")) {
        this.sort.spName = sortlist;
      } else if (label == this.$t("lang.softwarepackage.Version")) {
        this.sort.spVersion = sortlist;
      }
      else if(label == 'MD5'){
        this.sort.spVersion = sortlist;
      }
       else if (label == this.$t("lang.softwarepackage.types")) {
        this.sort.spType = sortlist;
      } else if (label == this.$t("lang.softwarepackage.Software")) {
        this.sort.spSize = sortlist;
      } else if (
        label == this.$t("lang.softwarepackage.adminhelpuploadusers")
      ) {
        this.sort.username = sortlist;
      } else if (label == this.$t("lang.softwarepackage.m_UploadOMeter")) {
        this.sort.spCreate = sortlist;
      }else if (label == this.$t("lang.softwarepackage.SynchronizationStatus")) {
        this.sort.spSynStatus = sortlist;
      }
    },
    //设置固件权限,弹出固件权限弹出框
    SetFirmwarePermission(row){
      this.DialogShow=true
      this.spId=row.spId
      this.spPermission=row.spPermission
    },
    //接收固件权限弹出框返回值
    DialogResponse(props){
      this.DialogShow=props
    },
    //修改固件权限
    updateSoftwarePackagePermission(props){
      //提交修改
      updateSoftwarePackagePermission(this.spId,props)
      .then((res)=>{
        if(res.data.code===0){
          this.$message({
          message: this.$t("lang.softwarepackage.SuccessfullyModified"),
          type: 'success'
        });
        this.queryKeyword()
        }
        else {
          this.$message({
          message: this.$t("lang.softwarepackage.onCallModifying"),
          type: 'warning'
        })
        }
      })
    },
    //获取软件类型
    GetSoftwareType(row){
      switch (row.spType) {
        case "upgrade":
          return this.$t("lang.softwarepackage.UpgradePackage")
        case "升级包":
          return '升级包'
        case "patch":
          return this.$t("lang.softwarepackage.PatchPackage")
        case "normal":
          return this.$t("lang.softwarepackage.OrdinaryFile")
        default:return ''
      }
    },
    //获取上传用户
    GetUsername(row){
      return row.user.username
    },
    //获取同步状态
    GetStatus(status){
      return {status:status=='0'?'danger':'success',TagName:status=='0'?this.$t("lang.softwarepackage.NotSynchronized"):this.$t("lang.softwarepackage.Synced")}
    }
  },
  mounted() {
    this.getSoftwarePackageList();
    this.Permission = getPermission();
  }
};
</script>

<style scoped>
.elinput {
  margin: 0.2rem 0.2rem 0.2rem 0rem;
}
</style>
